import { TFunction } from 'i18next';
import { KpiObjectType } from '@/api/entities/kpi';
import { KpiTier } from '@/type/kpi-dashboard.types';
import {
  getKpiObjectLabel,
  KPI_TIER_COLORS,
} from '@/utils/kpi-dashboard.utils';

interface TierBreakdownCardListProps {
  t?: TFunction<undefined>;
  type: KpiObjectType;
  tierCounts: Record<KpiTier, number>;
}

const TIER_ORDER: KpiTier[] = ['strong', 'moderate', 'weak'];

export const TierBreakdownCardList = ({
  t,
  type,
  tierCounts,
}: TierBreakdownCardListProps) => {
  return (
    <div className="grid grid-cols-3 gap-3 max-lg:grid-cols-1">
      {TIER_ORDER.map((tier) => {
        const tierColor = KPI_TIER_COLORS[tier];

        return (
          <div
            key={tier}
            className="rounded-lg border border-gray-DBDFE9 bg-white px-4.5 py-5"
          >
            <div className="flex gap-2">
              <span
                className="mt-0.5 h-2.5 w-2.5 shrink-0 rounded-full"
                style={{ background: tierColor?.solid }}
              />
              <span className="text-[11.8px] font-medium uppercase tracking-wide text-gray-78829D [word-spacing:1px]">
                {t(tier, {
                  objects: getKpiObjectLabel(t, type, tierCounts?.[tier] ?? 0),
                })}
              </span>
            </div>
            <p
              className="mt-1 text-2xl font-bold tabular-nums"
              // style={{ color: tierColor?.text }}
              style={{ color: tierColor?.solid }}
            >
              {tierCounts?.[tier] ?? 0}
            </p>
          </div>
        );
      })}
    </div>
  );
};
